module.exports = __webpack_public_path__ + "img/belgium-other-heart-diseases-male.bed53697.png";